import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderEntreprise from '../../header/headerEntreprise';
import MissionTabs from '../../commun/MissionTabs';
import MissionInfo from '../../commun/MissionInfo';
import ProfilRecherche from '../../commun/ProfilRecherche';
import InfosComplementaires from '../../commun/InfosComplementaires';
import ContactCard from '../../commun/ContactCard';
import InfoCard from '../../commun/InfoCard';
import CustomAlert from '../../commun/CustomAlert';
import HistoriqueTab from '../../Recruteur/candidat/detailTalent/HistoriqueTab'; 
import './Detailsmission.css';
import Chatbox from '../../commun/ChatBox';
import Footer from '../../commun/Footer';
import LoadingPopup from '../../commun/LoadingPopup';

const Detailsmission = () => {
  const entrepriseName = localStorage.getItem("entrepriseName");
  const { id } = useParams();
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const [mission, setMission] = useState(null);
  const [editedMission, setEditedMission] = useState({});
  const [activeTab, setActiveTab] = useState('mission');
  const [isEditing, setIsEditing] = useState(false);
  const [candidatures, setCandidatures] = useState([]);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
  const [entreprise, setEntreprise] = useState(null);
  const [usersList, setUsersList] = useState([]);

  const showAlert = (message, severity = 'success') => {
    setAlert({ open: true, message, severity });
  };

  const handleCloseAlert = () => {
    setAlert({ ...alert, open: false });
  };

  useEffect(() => {
    const fetchMission = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/missions/${id}`);
        const data = await res.json();
        setMission(data);
        setEditedMission(data);
        fetchEntreprise(data.createdBy);
      } catch (err) {
        showAlert('Erreur lors du chargement de la mission.', 'error');
      }
    };

    const fetchEntreprise = async (userId) => {
  try {
    const res = await fetch(`${API_BASE}/api/entreprise/profil/${userId}`);
    const data = await res.json();
    setEntreprise(data);

    const users = [
      {
        id: data.utilisateur?._id,
        nom: `${data.utilisateur?.firstName || ''} ${data.utilisateur?.lastName || ''}`.trim(),
        email: data.utilisateur?.email,
        telephone: data.utilisateur?.phone,
      },
      ...(data.utilisateursAdditionnels || []).map(u => ({
        id: u._id,
        nom: `${u.firstName || ''} ${u.lastName || ''}`.trim(),
        email: u.email,
        telephone: u.phone,
      }))
    ].filter(u => u.email);

    setUsersList(users);
  } catch (err) {
    showAlert('Erreur lors du chargement de l’entreprise.', 'error');
  }
};


    const fetchCandidatures = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/candidatures/mission/${id}`);
        const data = await res.json();
        setCandidatures(data);
      } catch (err) {
        showAlert('Erreur lors du chargement des candidatures.', 'error');
      }
    };

    fetchMission();
    fetchCandidatures();
  }, [id]);

  const handleChange = (field, value) => {
    setEditedMission(prev => ({ ...prev, [field]: value }));
  };

  const handleToggleStatus = async () => {
    const newStatus = editedMission.status === 'active' ? 'inactive' : 'active';
    try {
      const res = await fetch(`${API_BASE}/api/missions/${editedMission._id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...editedMission, status: newStatus })
      });

      if (res.ok) {
        handleChange('status', newStatus);
        setMission(prev => ({ ...prev, status: newStatus }));
        showAlert(`Statut changé en ${newStatus.toUpperCase()}`, 'success');
      } else {
        showAlert('Erreur lors du changement de statut.', 'error');
      }
    } catch (err) {
      showAlert('Erreur serveur lors du changement de statut.', 'error');
    }
  };

 const handleSave = async () => {
  try {
    
    if (!editedMission.regionTravail && editedMission.lieuxTravail) {
      editedMission.regionTravail = editedMission.lieuxTravail;
    }

    let body, headers;

      if (editedMission.document instanceof File) {
        body = new FormData();
        for (const key in editedMission) {
          if (key === 'document') {
            body.append('document', editedMission.document);
          } else {
            body.append(key, editedMission[key]);
          }
        }
        headers = {};
      } else {
        body = JSON.stringify(editedMission);
        headers = { "Content-Type": "application/json" };
      }

      const res = await fetch(`${API_BASE}/api/missions/${editedMission._id}`, {
        method: "PUT",
        headers,
        body
      });

      if (res.ok) {
        const updated = await res.json();
        setMission(updated.mission);
        setIsEditing(false);
        showAlert('Modification réussie.', 'success');
      } else {
        showAlert('Erreur lors de la mise à jour.', 'error');
      }
    } catch (err) {
      showAlert('Erreur serveur lors de la mise à jour.', 'error');
    }
  };

  if (!mission) return <LoadingPopup open={true} message="Chargement..." />;

  return (
    <div className="entreprise-page">
      <HeaderEntreprise entrepriseName={entrepriseName} />

      <main className="pageContainer">
        <div className="contentWrapper">
          <div className="contentGrid">
  {/* ✅ Colonne gauche */}
  <aside className="leftColumn">
    <ContactCard
      mission={editedMission}
      editable={isEditing}
      onChange={handleChange}
      utilisateur={mission.utilisateur}
      users={usersList}
    />
  </aside>

  {/* ✅ Colonne principale */}
  <section className="mainColumn">
    <div className="missionContent">
      <MissionTabs activeTab={activeTab} setActiveTab={setActiveTab} viewerType="entreprise" />
      {activeTab === 'mission' && (
        <MissionInfo
          mission={mission}
          editedMission={editedMission}
          editable={isEditing}
          onChange={handleChange}
          onSave={handleSave}
          onToggleStatus={handleToggleStatus}
          onToggleEdit={() => setIsEditing(prev => !prev)}
          showActionButtons={true}
          entrepriseLogo={entreprise?.logo}
        />
      )}
      {activeTab === 'profil' && (
        <ProfilRecherche
          editedMission={editedMission}
          editable={isEditing}
          onChange={handleChange}
          onSave={handleSave}
          onToggleEdit={() => setIsEditing(prev => !prev)}
          showActionButtons={true}
          entrepriseLogo={entreprise?.logo}
        />
      )}
      {activeTab === 'infos' && (
        <InfosComplementaires candidatures={candidatures} viewerType="entreprise" />
      )}
      {activeTab === 'historique' && (
        <HistoriqueTab historique={mission.historique || []} />
      )}
    </div>
  </section>

  {/* ✅ Colonne droite */}
  <aside className="rightColumn">
    <InfoCard
      mission={editedMission}
      editable={isEditing}
      onChange={handleChange}
    />
  </aside>
</div>

        </div>
      </main>

      <Footer />

      <CustomAlert
        open={alert.open}
        message={alert.message}
        severity={alert.severity}
        onClose={handleCloseAlert}
      />

      <Chatbox userRole="entreprise" />
    </div>
  );
};

export default Detailsmission;
